import { z } from 'zod';
/**
 * Skill-Architektur (Plan §18) — modulare Capabilities mit einheitlicher Manifest-Schnittstelle.
 * Ein Skill kann Backend-Routes, UI-Komponenten (über Slots) und Hooks liefern.
 * Skills lassen sich pro Tenant aktivieren/deaktivieren (Phase 9-Stretch).
 */
export const skillCategory = z.enum([
    'ai',
    'core',
    'collaboration',
    'data',
    'docs',
    'graphics',
    'integration',
    'plugin',
    'security',
    'ui',
]);
/** Definierte UI-Slots, die das Core-Frontend bereitstellt. */
export const KNOWN_SLOTS = {
    GLOBAL_TOPBAR: 'global.topbar',
    GLOBAL_TOPBAR_ACTIONS: 'global.topbar.actions',
    GLOBAL_FOOTER: 'global.footer',
    GLOBAL_BOT: 'global.bot',
    DASHBOARD_STATS: 'dashboard.stats',
    DASHBOARD_WIDGETS: 'dashboard.widgets',
    PROJECT_DETAIL_HEADER: 'project-detail.header',
    PROJECT_DETAIL_COCKPIT: 'project-detail.cockpit',
    PROJECT_DETAIL_COCKPIT_BELOW: 'project-detail.cockpit.below',
    PROJECT_DETAIL_TABS: 'project-detail.tabs',
    PROJECT_DETAIL_SIDEBAR: 'project-detail.sidebar',
    PROJECT_DETAIL_FIELD_HELP: 'project-detail.field-help',
    PROJECT_LIST_TOOLBAR: 'project-list.toolbar',
    CUSTOMER_DETAIL_TABS: 'customer-detail.tabs',
    WIZARD_STEP1_AFTER_CUSTOMER: 'wizard.step1.after-customer',
};
